import React from "react";

import { useIntl } from "react-intl";

import { AddButton } from "ds/Button";
import { Tooltip } from "ds/Tooltip";

import * as S from "./Empty.styles";

type EmptyProps = {
  onClick: () => void;
  disabled: boolean;
  tooltipId: string;
};
const Empty = ({ onClick, disabled, tooltipId }: EmptyProps) => {
  const intl = useIntl();

  const addBtn = (
    <AddButton
      id="add-new-variable"
      analyticId="settings.variables.add.button"
      onClick={onClick}
      disabled={disabled}
    >
      {intl.formatMessage({
        id: "settings.variables.add.button"
      })}
    </AddButton>
  );
  const addEl = disabled ? (
    <Tooltip
      tooltip={intl.formatMessage({
        id: tooltipId
      })}
      analyticId={tooltipId}
    >
      {addBtn}
    </Tooltip>
  ) : (
    addBtn
  );

  return (
    <S.Wrapper>
      <p>
        {intl.formatMessage({
          id: "settings.variables.empty"
        })}
      </p>
      {addEl}
    </S.Wrapper>
  );
};

export default Empty;
